import { jwtDecode } from 'jwt-decode'

import { ACCESS_TOKEN_KEY } from '@/constants/app'
import { apiClient } from '@/lib/apiClient'

/**
 * Single place that owns the access token: storage plus the default
 * Authorization header. Passing `null` signs the session out.
 */
export const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem(ACCESS_TOKEN_KEY, accessToken)
    apiClient.defaults.headers.common.Authorization = `Bearer ${accessToken}`
    return
  }

  localStorage.removeItem(ACCESS_TOKEN_KEY)
  delete apiClient.defaults.headers.common.Authorization
}

export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY)

/** Rejects malformed and expired tokens without a network round trip. */
export const isAccessTokenValid = (accessToken) => {
  if (!accessToken) return false

  try {
    const { exp } = jwtDecode(accessToken)
    if (!exp) return true
    return exp > Date.now() / 1000
  } catch {
    return false
  }
}
